import { Injectable } from '@angular/core';
import { LocationWeeklySchedule } from '@evermile/api/model/locationWeeklySchedule';

export enum errorType {
  NONE = 'none',
  M25 = 'isM25Address',
  SAME = 'isSameArea',
  POSTAL = 'postalCodeError',
  OVERLAP = 'overlappingAddressError',
  INVALID = 'invalidAddress',
}

export const errorMessagesMap: any = {
  [errorType.POSTAL]:
    'The address you selected is incomplete. Please provide an address with a postcode & street name and number',
  [errorType.M25]: 'This location is outside of Evermile’s service area. Please select a different address.',
  [errorType.INVALID]: 'Invalid address.',
};

@Injectable({
  providedIn: 'root',
})
export class AddressUtils {
  getModifiedOpeningHoursObject(openingHours: LocationWeeklySchedule | any) {
    for (const day in openingHours) {
      openingHours[day].start = openingHours[day].start || openingHours[day].openWindowStart;
      openingHours[day].end = openingHours[day].end || openingHours[day].openWindowEnd;
    }
    return openingHours;
  }
}
